import { render, staticRenderFns } from "./DetailProductCategoryComponent.vue?vue&type=template&id=562092fb&scoped=true"
import script from "./DetailProductCategoryComponent.vue?vue&type=script&lang=js"
export * from "./DetailProductCategoryComponent.vue?vue&type=script&lang=js"
import style0 from "./DetailProductCategoryComponent.vue?vue&type=style&index=0&id=562092fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "562092fb",
  null
  
)

export default component.exports